
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Params, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@services/authentication.service';
import { CommonService } from '@services/app.common.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';



@Injectable()
export class LoginResolver  {
  constructor(public authService: AuthenticationService, private router: Router, private common: CommonService) {
    // this.route.queryParams.subscribe((params: Params) => {
    //  this.TalentCommunityId = params['TalentCommunityId'];
    // });
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.authService.getAntiForgeryToken().pipe(map(data => {
      return data;
    }));
  }
}
